import { render } from "./ReplyInquiry.vue?vue&type=template&id=e9873e5e&scoped=true"
import script from "./ReplyInquiry.vue?vue&type=script&lang=js"
export * from "./ReplyInquiry.vue?vue&type=script&lang=js"

import "./ReplyInquiry.vue?vue&type=style&index=0&id=e9873e5e&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9873e5e"]])

export default __exports__